
import ReactMarkdown from "react-markdown"
import { motion } from "framer-motion"
import { API } from "../../../api/api"

type ExplanationProps = {
  headline: string
  text: string
}

export default function Explanation({ headline, text }: ExplanationProps) {
  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col lg:flex-row py-32 max-w-page mx-auto px-4 md:px-8 xl:px-0">
        <motion.div
          className="w-full min-w-[350px] lg:pr-16 pb-6 lg:pb-0"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h5 className="text-4xl font-semibold font-headline">{headline}</h5>
        </motion.div>

        <motion.div
          className="lg:pl-16 lg:border-l lg:border-base-300/70"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="text-lg markdown-content !leading-loose">
            <ReactMarkdown
              components={{
                p: ({ children }) => <p className="font-text opacity-75 text-md">{children}</p>,
                img: ({ src, alt }) => (
                  <img src={API.img + src} alt={alt} className="w-fit h-full max-h-96 object-cover rounded-default mx-auto" />
                ),
                a: ({ href, children }) => (
                  <a href={href} className="text-primary underline">
                    {children}
                  </a>
                ),
                ul: ({ children }) => <ul className="list-disc list-inside">{children}</ul>,
                strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
                h1: ({ children }) => <h1 className="text-3xl font-semibold font-headline pb-2">{children}</h1>,
                h2: ({ children }) => <h2 className="text-2xl font-semibold font-headline pb-2">{children}</h2>,
                h3: ({ children }) => <h3 className="text-xl font-semibold font-headline pb-1">{children}</h3>,
                h4: ({ children }) => <h4 className="text-lg font-semibold font-headline pb-1">{children}</h4>,
                h5: ({ children }) => <h5 className="text-base font-semibold font-headline pb-1">{children}</h5>,
                h6: ({ children }) => <h6 className="text-sm font-semibold font-headline">{children}</h6>,
              }}
            >
              {text}
            </ReactMarkdown>
          </div>
        </motion.div>
      </div>
    </div>
  )
}
